import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown, Menu, X } from 'lucide-react';

const HEADER_NAV = [
  { label: 'Spending', children: [
    { label: 'Latest quarter', href: '/latest-quarter' },
    { label: 'All-time', href: '/all-time' },
    { label: 'Contracts', href: '/contracts' },
    { label: 'Donations', href: '/donations' },
    { label: 'Projects', href: '/projects' },
  ] },
  { label: 'Accountability', children: [
    { label: 'Health transfer', href: '/health-transfer' },
    { label: 'Immigration', href: '/immigration' },
    { label: 'Disability programs', href: '/disability' },
    { label: 'Housing', href: '/housing' },
    { label: 'Public sector', href: '/public-sector' },
  ] },
  { label: 'Analysis', children: [
    { label: 'Where $100 goes', href: '/federal-spending-100' },
    { label: 'Inflation · what got more expensive', href: '/inflation' },
    { label: 'The Squeeze · immigration & housing', href: '/the-squeeze' },
  ] },
  { label: 'Explore', children: [
    { label: 'Outliers', href: '/outliers' },
    { label: 'Categories', href: '/categories' },
    { label: 'Compare', href: '/compare' },
  ] },
  { label: 'News', href: '/news' },
  { label: 'Methodology', href: '/methodology' },
];

export default function Header() {
  const [openIdx, setOpenIdx] = useState(null);
  const [mobile, setMobile] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="bg-ink-800 text-cream-100 relative z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-baseline gap-2 group">
          <span className="font-serif italic font-light text-2xl tracking-tight text-cream-100 group-hover:text-copper-500 transition">Spill the Hill</span>
          <span className="kicker text-copper-500 opacity-80">Canada</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {HEADER_NAV.map((item, i) => {
            const active = item.href === pathname;
            return (
              <div
                key={item.label}
                className="relative"
                onMouseEnter={() => item.children && setOpenIdx(i)}
                onMouseLeave={() => setOpenIdx(null)}
              >
                {item.children ? (
                  <button className="px-3.5 py-2 text-[13.5px] text-cream-100/80 hover:text-cream-100 inline-flex items-center gap-1 transition">
                    {item.label}
                    <ChevronDown size={13} className="opacity-60" />
                  </button>
                ) : (
                  <Link
                    to={item.href}
                    className={`px-3.5 py-2 text-[13.5px] inline-block transition ${active ? 'text-copper-500' : 'text-cream-100/80 hover:text-cream-100'}`}
                  >
                    {item.label}
                  </Link>
                )}

                {item.children && openIdx === i && (
                  <div className="absolute top-full left-0 pt-2">
                    <div className="min-w-[220px] bg-cream-50 border border-ink-300 rounded-sm shadow-xl py-2">
                      {item.children.map((c) => (
                        <Link
                          key={c.label}
                          to={c.href}
                          className={`block px-4 py-2 text-[13.5px] hover:bg-cream-100 hover:text-copper-600 transition ${pathname === c.href ? 'text-copper-600 font-medium' : 'text-ink-700'}`}
                        >
                          {c.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          <Link
            to="/latest-quarter"
            className="ml-4 inline-flex items-center gap-1.5 bg-copper-500 hover:bg-copper-600 text-cream-50 px-4 py-2 text-[13px] font-medium tracking-wide rounded-sm transition"
          >
            View latest report
          </Link>
        </nav>

        <button className="md:hidden p-2 text-cream-100" onClick={() => setMobile(!mobile)} aria-label="menu">
          {mobile ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {mobile && (
        <div className="md:hidden border-t border-ink-900 bg-ink-800">
          <div className="px-6 py-4 space-y-3">
            {HEADER_NAV.map((item) => (
              <div key={item.label}>
                <div className="kicker text-copper-500 py-1">{item.label}</div>
                {item.children ? (
                  item.children.map((c) => (
                    <Link key={c.label} to={c.href} className="block py-1.5 text-[15px] text-cream-100/90" onClick={() => setMobile(false)}>
                      {c.label}
                    </Link>
                  ))
                ) : (
                  <Link to={item.href} className="block py-1.5 text-[15px] text-cream-100/90" onClick={() => setMobile(false)}>
                    {item.label}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
